/*
 * サブシステム名：
 * 機能名：受注・実績一覧
 */
import { mapGetters } from 'vuex'
import filter from '@/rahmen/utils/filters'
import flowMixin from '@/mixins/flowMixins'
import validators from '@/rahmen/validators'

import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'
import indexeddb from '@/ddv2.library/indexeddb'
import modals from '@/ddv2.library/modals'

import DdSearchList from '@/components/DdSearchList'
import DdCheckbox from '@/components/DdCheckbox'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdDateRangeBox from '@/components/DdDateRangeBox'
import DdDropDown from '@/components/DdDropDown'
import DdRadioButton from '@/components/DdRadioButton'
import DdTextBox from '@/components/DdTextBox'

export default {
  name: 'PrmHaishaList',
  mixins: [flowMixin],
  components: {
    DdSearchList,
    DdCheckbox,
    DdCodeTextBox,
    DdDateRangeBox,
    DdDropDown,
    DdRadioButton,
    DdTextBox
  },
  data: () => ({
    selected: [],
    itemsPerPage: 100,
    page: 1,

    rows: [],
    conditions: {},
    conditionDetails: [
      { key: 'haishaTantoJininId', name: '配車担当者', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'mstjinin' },
      { key: 'unkoYmdFromTo', name: '運行予定日', value: 'unkoYmdFromTo', type: 'value', delete: true, showValue: true, convertValue: false },
      { key: 'jissekiTorokuKbnNm', name: '実績確認状況', value: 'jissekiTorokuKbnNm', type: 'value', delete: false, showValue: true, convertValue: false },
      { key: 'jissekiKakuninKbnNm', name: '実績確認状況', value: 'jissekiKakuninKbnNm', type: 'value', delete: false, showValue: true, convertValue: false },
      { key: 'haishaEigyoshoId', name: '営業所', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msteigyosho' },
      { key: 'tokuisakiId', name: '得意先', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msttorihikisaki' },
      { key: 'sharyoId', name: '車両', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'mstsharyo' },
      { key: 'jomuinJininId', name: '乗務員', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'mstjinin' },
      { key: 'hacchusakiId', name: '傭車先', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msttorihikisaki' },
      { key: 'haishaStatusKbnNm', name: '配車状況', value: 'haishaStatusKbnNm', type: 'value', delete: false, showValue: true, convertValue: false },
      { key: 'haishasakiKbnNm', name: '配車先', value: 'haishasakiKbnNm', type: 'value', delete: false, showValue: true, convertValue: false },
      { key: 'meisaiHeadFlg', name: '先頭の受注のみ表示', value: null, type: 'checkbox', delete: true, showValue: false, convertValue: false }
    ],

    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstJininHeaders: header.mstJininHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,
    mstSharyoHeaders: header.vwCMstSharyoHeaders,
    modeKengen: 0
  }),
  watch: {
    /**
     * 検索条件簡易表示用
     * @param {} n
     */
    // 運行予定日
    'conditions.unkoYoteiStartYmdString': function (n) {
      var unkoYmdFromTo = ![undefined, null, ''].includes(this.conditions.unkoYoteiStartYmdString) ? this.conditions.unkoYoteiStartYmdString.slice(-5) : ''
      unkoYmdFromTo = unkoYmdFromTo + (![undefined, null, ''].includes(this.conditions.unkoYoteiEndYmdString) ? '～' + this.conditions.unkoYoteiEndYmdString.slice(-5) : '')
      this.conditions.unkoYmdFromTo = unkoYmdFromTo
    },
    'conditions.unkoYoteiEndYmdString': function (n) {
      var unkoYmdFromTo = ![undefined, null, ''].includes(this.conditions.unkoYoteiStartYmdString) ? this.conditions.unkoYoteiStartYmdString.slice(-5) : ''
      unkoYmdFromTo = unkoYmdFromTo + (![undefined, null, ''].includes(this.conditions.unkoYoteiEndYmdString) ? '～' + this.conditions.unkoYoteiEndYmdString.slice(-5) : '')
      this.conditions.unkoYmdFromTo = unkoYmdFromTo
    },
    // 実績登録状況
    'conditions.jissekiTorokuKbn': function (n) {
      this.conditions.jissekiTorokuKbnNm = this.conditions.jissekiTorokuKbn === '01' ? '済' : this.conditions.jissekiTorokuKbn === '02' ? '未' : '全て'
    },
    // 実績確認状況
    'conditions.jissekiKakuninKbn': function (n) {
      this.conditions.jissekiKakuninKbnNm = this.conditions.jissekiKakuninKbn === '01' ? '済' : this.conditions.jissekiKakuninKbn === '02' ? '未' : '全て'
    },
    // 配車状況
    'conditions.haishaStatusKbn': function (n) {
      this.conditions.haishaStatusKbnNm = this.conditions.haishaStatusKbn === '01' ? '確定分' : this.conditions.haishaStatusKbn === '02' ? '未確定分' : '全て'
    },
    // 配車先
    'conditions.haishasakiKbn': function (n) {
      this.conditions.haishasakiKbnNm = this.conditions.haishasakiKbn === '02' ? '自営業所分' : this.conditions.haishasakiKbn === '03' ? '他営業所分' : this.conditions.haishasakiKbn === '04' ? '傭車分' : '全て'
    }
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      sharyoList: 'DDMasters/vwCMstSharyo',
      shubetsuList: 'DDMasters/mstShubetsu',
      currentKaishaCode: 'users/currentKaishaCode',
      usersEigyoshoCd: 'users/eigyoshoCd',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        elem.juchuJissekiId = String(elem.keikakujissekikey) + String(elem.juchuNo)
        elem.unkoYmdDisp = elem.unkoYmd ? filter.dateFormatter(elem.unkoYmd) : ''
        elem.keikakuKakuteiFlgDisp = elem.keikakuKakuteiFlg ? '〇' : ''
        elem.jissekiTorokuKbnDisp = elem.trUnkoJissekiId > 0 ? '〇' : ''
        elem.jissekiKakuninZumiFlgDisp = elem.jissekiKakuninZumiFlg ? '〇' : ''
        elem.haishaEigyoshoDisp = elem.haishaEigyoshoCd ? elem.haishaEigyoshoCd + ' : ' + elem.haishaEigyoshoNm : ''
        elem.haishaTantoshaDisp = elem.haishaTantoJininCd ? elem.haishaTantoJininCd + ' : ' + elem.haishaTantoJininNm : ''
        elem.hacchusakiDisp = elem.hacchusakiCd ? elem.hacchusakiCd + ' : ' + elem.hacchusakiNm : ''
        elem.sharyoDisp = elem.sharyoNo ? elem.sharyoNo + ' : ' + elem.torokuNo : elem.torokuNo ? elem.torokuNo : ''
        elem.jomuinDisp = elem.jomuinJininCd ? elem.jomuinJininCd + ' : ' + elem.jomuinJininNmSei : ''
        elem.dojoshaDisp = elem.joshuJininCd ? elem.joshuJininCd + ' : ' + elem.joshuJininNmSei : ''
        elem.juchuEigyoshoDisp = elem.juchuEigyoshoCd ? elem.juchuEigyoshoCd + ' : ' + elem.juchuEigyoshoNm : ''
        elem.tokuisakiDisp = elem.tokuisakiCd ? elem.tokuisakiCd + ' : ' + elem.tokuisakiNm : ''
        elem.unchinKakuteiFlgDisp = elem.unchinKakuteiFlg ? '〇' : ''
        elem.seikyuTomeFlgDisp = elem.seikyuTomeFlg ? '〇' : ''
        elem.hatsuchiDisp = elem.hatsuchiCd ? elem.hatsuchiCd + ' : ' + elem.hatsuchiNm : elem.hatsuchiBiko
        elem.hatsuchiYmdDisp = elem.hatsuchiYmd ? filter.dateFormatter(elem.hatsuchiYmd) : ''
        elem.hatsuchiHmsDisp = elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : ''
        elem.keiyuchi1Disp = elem.keiyuchi1Cd ? elem.keiyuchi1Cd + ' : ' + elem.keiyuchi1Nm : elem.keiyuchiId1Biko
        elem.keiyuchi2Disp = elem.keiyuchi2Cd ? elem.keiyuchi2Cd + ' : ' + elem.keiyuchi2Nm : elem.keiyuchiId2Biko
        elem.keiyuchi3Disp = elem.keiyuchi3Cd ? elem.keiyuchi3Cd + ' : ' + elem.keiyuchi3Nm : elem.keiyuchiId3Biko
        elem.keiyuchi4Disp = elem.keiyuchi4Cd ? elem.keiyuchi4Cd + ' : ' + elem.keiyuchi4Nm : elem.keiyuchiId4Biko
        elem.keiyuchi5Disp = elem.keiyuchi5Cd ? elem.keiyuchi5Cd + ' : ' + elem.keiyuchi5Nm : elem.keiyuchiId5Biko
        elem.chakuchiDisp = elem.chakuchiCd ? elem.chakuchiCd + ' : ' + elem.chakuchiNm : elem.chakuchiBiko
        elem.chakuchiYmdDisp = elem.chakuchiYmd ? filter.dateFormatter(elem.chakuchiYmd) : ''
        elem.chakuchiHmsDisp = elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : ''
        elem.hinmeiDisp = elem.hinmeiCd ? elem.hinmeiCd + ' : ' + elem.hinmeiNm : elem.hinmeiBiko
        elem.juchuSuryoDisp = elem.juchuSuryo ? filter.numericFormatter(elem.juchuSuryo) : ''
        elem.tankaDisp = elem.tanka ? filter.numericFormatter(elem.tanka) : 0
        elem.juchuJuryoDisp = elem.juchuJuryo ? filter.numericFormatter(elem.juchuJuryo) : ''
        elem.seikyuYoteiYmdDisp = elem.seikyuYoteiYmd ? filter.dateFormatter(elem.seikyuYoteiYmd) : ''
        elem.kihonUnchinDisp = elem.kihonUnchin ? filter.numericFormatter(elem.kihonUnchin) : 0
        elem.hokanKingakuDisp = elem.hokanKingaku ? filter.numericFormatter(elem.hokanKingaku) : 0
        elem.niekiKingakuDisp = elem.niekiKingaku ? filter.numericFormatter(elem.niekiKingaku) : 0
        elem.unchinHokaKingakuDisp = elem.unchinHokaKingaku ? filter.numericFormatter(elem.unchinHokaKingaku) : 0
        elem.hiwayPriceDisp = elem.hiwayPrice ? filter.numericFormatter(elem.hiwayPrice) : 0
        elem.unchinHokaHikazeiDisp = elem.unchinHokaHikazei ? filter.numericFormatter(elem.unchinHokaHikazei) : 0
        elem.tatekaekinHikazeiDisp = elem.tatekaekinHikazei ? filter.numericFormatter(elem.tatekaekinHikazei) : 0
        elem.jikanWarimashiKingakuDisp = elem.jikanWarimashiKingaku ? filter.numericFormatter(elem.jikanWarimashiKingaku) : 0
        elem.kyoriWarimashiKingakuDisp = elem.kyoriWarimashiKingaku ? filter.numericFormatter(elem.kyoriWarimashiKingaku) : 0
        elem.warimashiSonotaKingakuDisp = elem.warimashiSonotaKingsku ? filter.numericFormatter(elem.warimashiSonotaKingsku) : 0
        elem.yoshaKihonUnchinDisp = elem.yoshaKihonUnchin ? filter.numericFormatter(elem.yoshaKihonUnchin) : 0
        elem.yoshaHiwayPriceDisp = elem.yoshaHiwayPrice ? filter.numericFormatter(elem.yoshaHiwayPrice) : 0
        elem.sagyoinTeateKingaku1Disp = elem.sagyoinTeateKingaku1 ? filter.numericFormatter(elem.sagyoinTeateKingaku1) : 0
        elem.sharyoKeihiHiwayEtcDisp = elem.sharyoKeihiHiwayEtc ? filter.numericFormatter(elem.sharyoKeihiHiwayEtc) : 0
        elem.sharyoKeihiHiwayGenkinDisp = elem.sharyoKeihiHiwayGenkin ? filter.numericFormatter(elem.sharyoKeihiHiwayGenkin) : 0
        elem.sharyoKeihiFerryDisp = elem.sharyoKeihiFerry ? filter.numericFormatter(elem.sharyoKeihiFerry) : 0
        elem.sharyoKeihiEtc1Disp = elem.sharyoKeihiEtc1 ? filter.numericFormatter(elem.sharyoKeihiEtc1) : 0
        return elem
      }).sort((a, b) => {
        if (a.meisaiOrder > b.meisaiOrder) { return 1 }
        if (a.meisaiOrder === b.meisaiOrder) { return 0 }
        return -1
      }).sort((a, b) => {
        if (a.unkoYmd > b.unkoYmd) { return 1 }
        if (a.unkoYmd === b.unkoYmd) { return 0 }
        return -1
      })
    },
    // 営業所フィルター
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
      })
    },
    // 人員フィルター
    filteredJininList () {
      const self = this
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoJininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target &&
        (self.eigyoshoLockFlg || elem.eigyoshoCd === self.usersEigyoshoCd)
      })
    },
    // 配車担当者フィルター
    filteredHaishaTantoshaList () {
      const self = this
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoJininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03' &&
        (self.eigyoshoLockFlg || elem.eigyoshoCd === self.usersEigyoshoCd)
      })
    },
    // 取引先フィルター
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    // 得意先フィルター
    filteredTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
      })
    },
    // 傭車先フィルター
    filteredMstHacchusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === true
      })
    },
    // 車両マスタフィルター
    filteredMstSharyoList () {
      const self = this
      const target = filter.dateFormatter(new Date())
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target &&
        (self.eigyoshoLockFlg || elem.eigyoshoCd === self.usersEigyoshoCd || elem.hacchusakiFlg)
      })
    },
    // 車両グループフィルター
    filteredSharyoGroup1ShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI012')
    },
    filteredSharyoGroup2ShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI013')
    },
    // CSVボタン活性条件
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    deleteButtonDisp () {
      // 現時点では使用しない
      // if (this.modeKengen === 2) {
      //   return true
      // } else {
      //   return false
      // }
      return false
    },
    isDeleteButtonDisabled () {
      if (this.modeKengen !== 2) {
        return true
      }
      if (this.selected.length > 0) {
        return false
      }
      return true
    },
    isEditButtonDisabled () {
      if (this.modeKengen === 0) {
        return true
      }
      if (this.selected.length === 1) {
        return false
      }
      return true
    },

    // 追加ボタン活性条件
    createButtonDisp () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize () {
      console.log('initialize')
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'vwcmsteigyoshojininlist', 'msttorihikisaki', 'vwcmstsharyo', 'mstshubetsu'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('PrmHaishaList.defineHeaderPromise')
            this.headers = [
              { text: '編集', value: 'actions', sortable: false, width: '20px' },
              { text: '運行予定日', value: 'unkoYmdDisp' },
              { text: '配車確定済', value: 'keikakuKakuteiFlgDisp', align: 'center' },
              { text: '実績登録済', value: 'jissekiTorokuKbnDisp', align: 'center' },
              { text: '運行実績No', value: 'unkoJissekiNo' },
              { text: '実績確認済', value: 'jissekiKakuninZumiFlgDisp', align: 'center' },
              { text: '配車営業所', value: 'haishaEigyoshoDisp' },
              { text: '配車先区分', value: 'haishasakiNm' },
              { text: '配車担当者', value: 'haishaTantoshaDisp' },
              { text: '乗務員', value: 'jomuinDisp' },
              { text: '同乗者', value: 'dojoshaDisp' },
              { text: '傭車先', value: 'hacchusakiDisp' },
              { text: '車両番号/ナンバープレート', value: 'sharyoDisp' },
              { text: '自動車表示名', value: 'jidoshaHyojiNm' },
              { text: '配送明細No', value: 'meisaiOrder' },
              { text: '受注No', value: 'juchuNo' },
              { text: '受注営業所', value: 'juchuEigyoshoDisp' },
              { text: '注文番号', value: 'chumonNo' },
              { text: '得意先', value: 'tokuisakiDisp' },
              { text: 'コース名', value: 'courseNm' },
              { text: '往復種別', value: 'ohfukuSbtNm' },
              { text: '運賃確定済み', value: 'unchinKakuteiFlgDisp', align: 'center' },
              { text: '請求止め対象', value: 'seikyuTomeFlgDisp', align: 'center' },
              { text: '発地', value: 'hatsuchiDisp' },
              { text: '発地年月日', value: 'hatsuchiYmdDisp' },
              { text: '発地時刻', value: 'hatsuchiHmsDisp' },
              { text: '経由地１', value: 'keiyuchi1Disp' },
              { text: '経由地２', value: 'keiyuchi2Disp' },
              { text: '経由地３', value: 'keiyuchi3Disp' },
              { text: '経由地４', value: 'keiyuchi4Disp' },
              { text: '経由地５', value: 'keiyuchi5Disp' },
              { text: '着地', value: 'chakuchiDisp' },
              { text: '着地年月日', value: 'chakuchiYmdDisp' },
              { text: '着地時刻', value: 'chakuchiHmsDisp' },
              { text: '品名', value: 'hinmeiDisp' },
              { text: '数量', value: 'juchuSuryoDisp', align: 'end' },
              { text: '単位', value: 'unitKbnNm' },
              { text: '重量(t)', value: 'juchuJuryoDisp', align: 'end' },
              { text: '単価', value: 'tankaDisp' },
              { text: '請求計上日', value: 'seikyuYoteiYmdDisp' },
              { text: '運賃計算区分', value: 'unchinKeisanKbnNm' },
              { text: '請求車種', value: 'seikyuShashuSbtNm' },
              { text: '運賃', value: 'kihonUnchinDisp', align: 'end' },
              { text: '保管料', value: 'hokanKingakuDisp', align: 'end' },
              { text: '荷役量', value: 'niekiKingakuDisp', align: 'end' },
              { text: '運賃(他)', value: 'unchinHokaKingakuDisp', align: 'end' },
              { text: '運賃(高速)', value: 'hiwayPriceDisp', align: 'end' },
              { text: '運賃他(非)', value: 'unchinHokaHikazeiDisp', align: 'end' },
              { text: '立替金(非)', value: 'tatekaekinHikazeiDisp', align: 'end' },
              { text: '割増金額(時間)', value: 'jikanWarimashiKingakuDisp', align: 'end' },
              { text: '割増金額(距離)', value: 'kyoriWarimashiKingakuDisp', align: 'end' },
              { text: '割増その他', value: 'warimashiSonotaKingakuDisp', align: 'end' },
              { text: '傭車額', value: 'yoshaKihonUnchinDisp', align: 'end' },
              { text: '傭車通行料', value: 'yoshaHiwayPriceDisp', align: 'end' },
              { text: '運行手当', value: 'sagyoinTeateKingaku1Disp', align: 'end' },
              { text: '高速ETC', value: 'sharyoKeihiHiwayEtcDisp', align: 'end' },
              { text: '高速現金', value: 'sharyoKeihiHiwayGenkinDisp', align: 'end' },
              { text: 'フェリー', value: 'sharyoKeihiFerryDisp', align: 'end' },
              { text: '社内傭車額', value: 'sharyoKeihiEtc1Disp', align: 'end' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('PrmHaishaList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            this.loadFromCache()
              .then((c) => {
                console.log('PrmHaishaList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('PrmHaishaList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('PrmHaishaList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
            resolve()
          })
        },
        settingViewScroll: () => {
          return false
        },
        settingButtonStatePromise: (kengen) => {
          console.log('PrmHaishaList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      // 選択状態初期化
      this.selected = []
      this.page = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2prmd0010/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            jissekiTorokuKbn: self.conditions.jissekiTorokuKbn,
            jissekiKakuninKbn: self.conditions.jissekiKakuninKbn,
            haishaStatusKbn: self.conditions.haishaStatusKbn,
            haishasakiKbn: self.conditions.haishasakiKbn
          }
        }
      }
      this.search(opt)
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      const today = filter.dateFormatter(new Date())
      const d = new Date()
      const initConditions = {
        unkoYoteiStartYmdString: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
        unkoYoteiEndYmdString: filter.dateFormatter(new Date()),
        haishaEigyoshoId: this.eigyoshoList.length > 0 ? indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyoshoCd, today).id : null,
        jomuinJininId: null,
        tokuisakiId: null,
        ninushiId: null,
        haishaTantoJininId: null,
        sharyoId: null,
        hacchusakiId: null,
        sharyoGroup1: null,
        sharyoGroup2: null,
        jissekiTorokuKbn: '03',
        jissekiKakuninKbn: '03',
        haishaStatusKbn: '03',
        haishasakiKbn: '01',
        meisaiHeadFlg: true,
        jissekiTorokuKbnNm: '全て',
        jissekiKakuninKbnNm: '全て',
        haishaStatusKbnNm: '全て',
        haishasakiKbnNm: '全て'
      }
      this.conditions = initConditions
      this.searchText = ''
      this.rows = []
      this.selected = []
      this.page = 1
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.initBindVariables()
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },

    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: [f.item.trUnkoJissekiId, f.item.keikakujissekikey, f.item.trJuchuKihonId] })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(0, { id: [item.trUnkoJissekiId, item.keikakujissekikey, item.trJuchuKihonId] })
    },

    onDeleteButtonClick: function (e) {
      var isDelete = true
      // 削除可能チェック
      // 必要があれば

      // 削除処理実行
      if (isDelete) {
        const p = modals.showConfirm
        p('COMQ0003').then((ok) => {
          if (ok === false || ok === undefined) { return }

          this.Effects.loadStart()

          for (const r of this.selected) {
            this.deleteExec(r.id).then(() => {
              // 再検索
              this.onSearchButtonClick()

              this.Effects.loadComplete()
              modals.showSuccess('対象を削除しました。')
            })
          }
        })
      } else {
        modals.showError('計画済・作業完了・実績確認済み・請求済みの受注は削除できません。<br>対象を見直してください。')
      }
    },
    deleteExec: function (id) {
      return new Promise((resolve) => {
        this.HttpClient.delete(`/api/v1/TrJuchuKihon/DeleteWithChildren?id=${id}&tm=${date.getCurrentDateTime()}`).then((data) => {
          resolve(data)
        })
      })
    },
    onEditButtonClick: function (e) {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(0, { id: [this.selected[0].trUnkoJissekiId, this.selected[0].keikakujissekikey] })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: [0, '0'] })
    },
    // 検索前チェック
    searchValidate: function () {
      // 運行予定年月日不整合チェック
      if (this.conditions.unkoYoteiStartYmdString && this.conditions.unkoYoteiEndYmdString) {
        const msg1 = validators.compareDate(this.conditions.unkoYoteiStartYmdString, this.conditions.unkoYoteiEndYmdString)
        if (msg1 !== undefined) {
          this.$refs.unkoYoteiStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.$refs.unkoYoteiEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.setInvalidSummaryMessage('COME0014')
          return false
        }
      }
      return true
    }
  }
}
